export default class ForbiddenError extends Error {
  constructor() {
    super('Forbidden');
    this.name = 'ForbiddenError';

    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}
